export function normalizeBowlingOvers(rawOvers) {
  if (rawOvers === null || rawOvers === undefined) {
    return rawOvers;
  }

  const oversString = String(rawOvers).trim();
  const oversMatch = oversString.match(/^(\d+)\.(\d+)$/);

  if (!oversMatch) {
    return oversString;
  }

  const [, wholeOvers, partialBalls] = oversMatch;
  if (partialBalls === '6') {
    return `${Number(wholeOvers) + 1}.0`;
  }

  return oversString;
}
